import React from 'react';
import Collapse from '@mui/material/Collapse';

import { Typography, Card, CardHeader, CardContent } from '@occc-app/design-system';

import { ActionCreators, ConstraintKeys } from '../redux';
import { Switch } from '../../Switch';

type Props = {
  children?: any;
  constraintToggleUpdate: ActionCreators['ConstraintToggleUpdate'];
  description: string;
  type: ConstraintKeys;
  isActive: boolean;
  name: string;
};

const ConstraintType: React.FC<Props> = ({
  children,
  constraintToggleUpdate,
  description,
  type,
  isActive,
  name,
}) => {
  const handleOnClick = () => {
    constraintToggleUpdate(type);
  };

  const renderTitle = () => (
    <Typography component='h4' variant='h6' gutterBottom>
      Configure {name} constraint (optional)
    </Typography>
  );
  const renderAction = () => (
    <Switch label={isActive ? 'On' : 'Off'} checked={isActive} onClick={handleOnClick} />
  );

  return (
    <Card variant='outlined'>
      <CardHeader
        title={renderTitle()}
        subheader={<Typography>{description}</Typography>}
        action={renderAction()}
      />
      <Collapse in={isActive} timeout='auto'>
        <CardContent>{children}</CardContent>
      </Collapse>
    </Card>
  );
};

export { ConstraintType };
